// Copyright (c) 2020 WiseTime. All rights reserved.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file legebill/site/tag/v4/tag.proto (package legebill.site.tag.v4, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, FieldMask, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_api_annotations } from "../../../../google/api/annotations_pb";
import type { DefaultTimesheetFieldValue, Tag, Tag_Source, Tag_SuggestionConfig, TagKeyword, TagKeywordSchema, TagSchema, TagShallow } from "../../../type/tag_pb";
import { file_legebill_type_tag } from "../../../type/tag_pb";
import type { TagCategory, TagCategorySchema } from "../../../type/tag_category_pb";
import { file_legebill_type_tag_category } from "../../../type/tag_category_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file legebill/site/tag/v4/tag.proto.
 */
export const file_legebill_site_tag_v4_tag: GenFile = /*@__PURE__*/
  fileDesc("Ch5sZWdlYmlsbC9zaXRlL3RhZy92NC90YWcucHJvdG8SFGxlZ2ViaWxsLnNpdGUudGFnLnY0Ih8KDUdldFRhZ1JlcXVlc3QSDgoGdGFnX2lkGAEgASgJIn0KEFVwZGF0ZVRhZ1JlcXVlc3QSCgoCaWQYASABKAkSLAoDdGFnGAIgASgLMh8ubGVnZWJpbGwuc2l0ZS50YWcudjQuVGFnVXBkYXRlEi8KC3VwZGF0ZV9tYXNrGAMgASgLMhouZ29vZ2xlLnByb3RvYnVmLkZpZWxkTWFzayLhAQoJVGFnVXBkYXRlEgwKBG5hbWUYASABKAkSEwoLZGVzY3JpcHRpb24YAiABKAkSPgoRc3VnZ2VzdGlvbl9jb25maWcYAyABKA4yIy5sZWdlYmlsbC50eXBlLlRhZy5TdWdnZXN0aW9uQ29uZmlnElEKHmRlZmF1bHRfdGltZXNoZWV0X2ZpZWxkX3ZhbHVlcxgFIAMoCzIpLmxlZ2ViaWxsLnR5cGUuRGVmYXVsdFRpbWVzaGVldEZpZWxkVmFsdWVKBAgEEAVSGGRlZmF1bHRfYWN0aXZpdHlfdHlwZV9pZCI0ChlMaXN0VGFnc0J5Q2F0ZWdvcnlSZXF1ZXN0EhcKD3RhZ19jYXRlZ29yeV9pZBgBIAEoCSI+ChpMaXN0VGFnc0J5Q2F0ZWdvcnlSZXNwb25zZRIgCgR0YWdzGAEgAygLMhIubGVnZWJpbGwudHlwZS5UYWciPAogQmF0Y2hMaXN0VGFnc0J5Q2F0ZWdvcmllc1JlcXVlc3QSGAoQdGFnX2NhdGVnb3J5X2lkcxgBIAMoCSJsCiFCYXRjaExpc3RUYWdzQnlDYXRlZ29yaWVzUmVzcG9uc2USRwoSdGFnc19ieV9jYXRlZ29yaWVzGAEgAygLMisubGVnZWJpbGwuc2l0ZS50YWcudjQuVGFnQ2F0ZWdvcnlNZW1iZXJzaGlwIlIKFVRhZ0NhdGVnb3J5TWVtYmVyc2hpcBIXCg90YWdfY2F0ZWdvcnlfaWQYASABKAkSIAoEdGFncxgCIAMoCzISLmxlZ2ViaWxsLnR5cGUuVGFnIk0KD0xpc3RUYWdzUmVxdWVzdBIPCgdzaXRlX2lkGAEgASgJEhEKCXBhZ2Vfc2l6ZRgCIAEoDRIWCg5yZXN1bHRzX29mZnNldBgDIAEoDSJLChBMaXN0VGFnc1Jlc3BvbnNlEiAKBHRhZ3MYASADKAsyEi5sZWdlYmlsbC50eXBlLlRhZxIVCg1yZXN1bHRzX2NvdW50GAIgASgEIjAKHURlbGV0ZUFsbENvbm5lY3RvclRhZ3NSZXF1ZXN0Eg8KB3NpdGVfaWQYASABKAkijAIKEVNlYXJjaFRhZ3NSZXF1ZXN0Eg8KB3NpdGVfaWQYASABKAkSEwoLc2VhcmNoX3RleHQYAiABKAkSEQoJcGFnZV9zaXplGAMgASgNEhIKCnBhZ2VfdG9rZW4YBSABKAkSQQoIb3JkZXJfYnkYBCABKA4yLy5sZWdlYmlsbC5zaXRlLnRhZy52NC5TZWFyY2hUYWdzUmVxdWVzdC5PcmRlckJ5EikKBnNvdXJjZRgGIAEoDjIZLmxlZ2ViaWxsLnR5cGUuVGFnLlNvdXJjZSI8CgdPcmRlckJ5EhgKFE9SREVSX0JZX1VOU1BFQ0lGSUVEEAASDQoJUkVMRVZBTkNFEAESCAoETkFNRRACImYKElNlYXJjaFRhZ3NSZXNwb25zZRIgCgR0YWdzGAEgAygLMhIubGVnZWJpbGwudHlwZS5UYWcSFQoNcmVzdWx0c19jb3VudBgCIAEoBBIXCg9uZXh0X3BhZ2VfdG9rZW4YAyABKAkiTAoZU2VhcmNoVGFnc1Jlc3BvbnNlU2hhbGxvdxIvCgx0YWdzX3NoYWxsb3cYASADKAsyGS5sZWdlYmlsbC50eXBlLlRhZ1NoYWxsb3ciJgoTQmF0Y2hHZXRUYWdzUmVxdWVzdBIPCgd0YWdfaWRzGAEgAygJIjgKFEJhdGNoR2V0VGFnc1Jlc3BvbnNlEiAKBHRhZ3MYASADKAsyEi5sZWdlYmlsbC50eXBlLlRhZyKLAgoQQ3JlYXRlVGFnUmVxdWVzdBIPCgdzaXRlX2lkGAEgASgJEgwKBG5hbWUYAiABKAkSEwoLZGVzY3JpcHRpb24YAyABKAkSEAoIa2V5d29yZHMYBCADKAkSPgoRc3VnZ2VzdGlvbl9jb25maWcYBiABKA4yIy5sZWdlYmlsbC50eXBlLlRhZy5TdWdnZXN0aW9uQ29uZmlnElEKHmRlZmF1bHRfdGltZXNoZWV0X2ZpZWxkX3ZhbHVlcxgHIAMoCzIpLmxlZ2ViaWxsLnR5cGUuRGVmYXVsdFRpbWVzaGVldEZpZWxkVmFsdWVKBAgFEAZSGGRlZmF1bHRfYWN0aXZpdHlfdHlwZV9pZCJFChdDcmVhdGVUYWdLZXl3b3JkUmVxdWVzdBIqCgdrZXl3b3JkGAEgASgLMhkubGVnZWJpbGwudHlwZS5UYWdLZXl3b3JkIkUKF0RlbGV0ZVRhZ0tleXdvcmRSZXF1ZXN0EioKB2tleXdvcmQYASABKAsyGS5sZWdlYmlsbC50eXBlLlRhZ0tleXdvcmQiKwoYTGlzdEZhdm91cml0ZVRhZ3NSZXF1ZXN0Eg8KB3NpdGVfaWQYASABKAkiVwoZTGlzdEZhdm91cml0ZVRhZ3NSZXNwb25zZRI6Cg5mYXZvdXJpdGVfdGFncxgBIAMoCzIiLmxlZ2ViaWxsLnNpdGUudGFnLnY0LkZhdm91cml0ZVRhZyKFAQoMRmF2b3VyaXRlVGFnEgoKAmlkGAEgASgJEh8KA3RhZxgCIAEoCzISLmxlZ2ViaWxsLnR5cGUuVGFnEhcKD3NpdGVfbGlzdF9pbmRleBgDIAEoDRIvCgtjcmVhdGVfdGltZRgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAiKwoZQ3JlYXRlRmF2b3VyaXRlVGFnUmVxdWVzdBIOCgZ0YWdfaWQYASABKAkiTwoaUmVvcmRlckZhdm91cml0ZVRhZ1JlcXVlc3QSGAoQZmF2b3VyaXRlX3RhZ19pZBgBIAEoCRIXCg9zaXRlX2xpc3RfaW5kZXgYAiABKA0iHQobUmVvcmRlckZhdm91cml0ZVRhZ1Jlc3BvbnNlIjUKGURlbGV0ZUZhdm91cml0ZVRhZ1JlcXVlc3QSGAoQZmF2b3VyaXRlX3RhZ19pZBgBIAEoCSJSChVMaXN0UmVjZW50VGFnc1JlcXVlc3QSDwoHc2l0ZV9pZBgBIAEoCRIRCglwYWdlX3NpemUYAiABKA0SFQoNYWN0aXZpdHlfZGF0ZRgDIAEoDSJBChZMaXN0UmVjZW50VGFnc1Jlc3BvbnNlEicKC3JlY2VudF90YWdzGAEgAygLMhIubGVnZWJpbGwudHlwZS5UYWciIgoQRGVsZXRlVGFnUmVxdWVzdBIOCgZ0YWdfaWQYASABKAkiMAoVR2V0VGFnQ2F0ZWdvcnlSZXF1ZXN0EhcKD3RhZ19jYXRlZ29yeV9pZBgBIAEoCSI4ChxCYXRjaEdldFRhZ0NhdGVnb3JpZXNSZXF1ZXN0EhgKEHRhZ19jYXRlZ29yeV9pZHMYASADKAkiUwodQmF0Y2hHZXRUYWdDYXRlZ29yaWVzUmVzcG9uc2USMgoOdGFnX2NhdGVnb3JpZXMYASADKAsyGi5sZWdlYmlsbC50eXBlLlRhZ0NhdGVnb3J5Mp0QCgpUYWdTZXJ2aWNlEkEKBkdldFRhZxIjLmxlZ2ViaWxsLnNpdGUudGFnLnY0LkdldFRhZ1JlcXVlc3QaEi5sZWdlYmlsbC50eXBlLlRhZxJlCgxCYXRjaEdldFRhZ3MSKS5sZWdlYmlsbC5zaXRlLnRhZy52NC5CYXRjaEdldFRhZ3NSZXF1ZXN0GioubGVnZWJpbGwuc2l0ZS50YWcudjQuQmF0Y2hHZXRUYWdzUmVzcG9uc2USRwoJQ3JlYXRlVGFnEiYubGVnZWJpbGwuc2l0ZS50YWcudjQuQ3JlYXRlVGFnUmVxdWVzdBoSLmxlZ2ViaWxsLnR5cGUuVGFnEkcKCVVwZGF0ZVRhZxImLmxlZ2ViaWxsLnNpdGUudGFnLnY0LlVwZGF0ZVRhZ1JlcXVlc3QaEi5sZWdlYmlsbC50eXBlLlRhZxJ3ChJMaXN0VGFnc0J5Q2F0ZWdvcnkSLy5sZWdlYmlsbC5zaXRlLnRhZy52NC5MaXN0VGFnc0J5Q2F0ZWdvcnlSZXF1ZXN0GjAubGVnZWJpbGwuc2l0ZS50YWcudjQuTGlzdFRhZ3NCeUNhdGVnb3J5UmVzcG9uc2USjAEKGUJhdGNoTGlzdFRhZ3NCeUNhdGVnb3JpZXMSNi5sZWdlYmlsbC5zaXRlLnRhZy52NC5CYXRjaExpc3RUYWdzQnlDYXRlZ29yaWVzUmVxdWVzdBo3LmxlZ2ViaWxsLnNpdGUudGFnLnY0LkJhdGNoTGlzdFRhZ3NCeUNhdGVnb3JpZXNSZXNwb25zZRJZCghMaXN0VGFncxIlLmxlZ2ViaWxsLnNpdGUudGFnLnY0Lkxpc3RUYWdzUmVxdWVzdBomLmxlZ2ViaWxsLnNpdGUudGFnLnY0Lkxpc3RUYWdzUmVzcG9uc2USkgEKFkRlbGV0ZUFsbENvbm5lY3RvclRhZ3MSMy5sZWdlYmlsbC5zaXRlLnRhZy52NC5EZWxldGVBbGxDb25uZWN0b3JUYWdzUmVxdWVzdBoWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eSIrgtPkkwIlIiMvYXBpL3Y0L3RhZ3MvZGVsZXRlYWxsY29ubmVjdG9ydGFncxJfCgpTZWFyY2hUYWdzEicubGVnZWJpbGwuc2l0ZS50YWcudjQuU2VhcmNoVGFnc1JlcXVlc3QaKC5sZWdlYmlsbC5zaXRlLnRhZy52NC5TZWFyY2hUYWdzUmVzcG9uc2USbQoRU2VhcmNoVGFnc1NoYWxsb3cSJy5sZWdlYmlsbC5zaXRlLnRhZy52NC5TZWFyY2hUYWdzUmVxdWVzdBovLmxlZ2ViaWxsLnNpdGUudGFnLnY0LlNlYXJjaFRhZ3NSZXNwb25zZVNoYWxsb3cSXAoQQ3JlYXRlVGFnS2V5d29yZBItLmxlZ2ViaWxsLnNpdGUudGFnLnY0LkNyZWF0ZVRhZ0tleXdvcmRSZXF1ZXN0GhkubGVnZWJpbGwudHlwZS5UYWdLZXl3b3JkElkKEERlbGV0ZVRhZ0tleXdvcmQSLS5sZWdlYmlsbC5zaXRlLnRhZy52NC5EZWxldGVUYWdLZXl3b3JkUmVxdWVzdBoWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eRJ0ChFMaXN0RmF2b3VyaXRlVGFncxIuLmxlZ2ViaWxsLnNpdGUudGFnLnY0Lkxpc3RGYXZvdXJpdGVUYWdzUmVxdWVzdBovLmxlZ2ViaWxsLnNpdGUudGFnLnY0Lkxpc3RGYXZvdXJpdGVUYWdzUmVzcG9uc2USaQoSQ3JlYXRlRmF2b3VyaXRlVGFnEi8ubGVnZWJpbGwuc2l0ZS50YWcudjQuQ3JlYXRlRmF2b3VyaXRlVGFnUmVxdWVzdBoiLmxlZ2ViaWxsLnNpdGUudGFnLnY0LkZhdm91cml0ZVRhZxJ6ChNSZW9yZGVyRmF2b3VyaXRlVGFnEjAubGVnZWJpbGwuc2l0ZS50YWcudjQuUmVvcmRlckZhdm91cml0ZVRhZ1JlcXVlc3QaMS5sZWdlYmlsbC5zaXRlLnRhZy52NC5SZW9yZGVyRmF2b3VyaXRlVGFnUmVzcG9uc2USXQoSRGVsZXRlRmF2b3VyaXRlVGFnEi8ubGVnZWJpbGwuc2l0ZS50YWcudjQuRGVsZXRlRmF2b3VyaXRlVGFnUmVxdWVzdBoWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eRJrCg5MaXN0UmVjZW50VGFncxIrLmxlZ2ViaWxsLnNpdGUudGFnLnY0Lkxpc3RSZWNlbnRUYWdzUmVxdWVzdBosLmxlZ2ViaWxsLnNpdGUudGFnLnY0Lkxpc3RSZWNlbnRUYWdzUmVzcG9uc2USSwoJRGVsZXRlVGFnEiYubGVnZWJpbGwuc2l0ZS50YWcudjQuRGVsZXRlVGFnUmVxdWVzdBoWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eRJZCg5HZXRUYWdDYXRlZ29yeRIrLmxlZ2ViaWxsLnNpdGUudGFnLnY0LkdldFRhZ0NhdGVnb3J5UmVxdWVzdBoaLmxlZ2ViaWxsLnR5cGUuVGFnQ2F0ZWdvcnkSgAEKFUJhdGNoR2V0VGFnQ2F0ZWdvcmllcxIyLmxlZ2ViaWxsLnNpdGUudGFnLnY0LkJhdGNoR2V0VGFnQ2F0ZWdvcmllc1JlcXVlc3QaMy5sZWdlYmlsbC5zaXRlLnRhZy52NC5CYXRjaEdldFRhZ0NhdGVnb3JpZXNSZXNwb25zZUIxChxjb20ubGVnZWJpbGwuYXBpLnNpdGUudGFnLnY0Qg9UYWdTZXJ2aWNlUHJvdG9QAWIGcHJvdG8z", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_field_mask, file_google_api_annotations, file_legebill_type_tag, file_legebill_type_tag_category]);

/**
 * @generated from message legebill.site.tag.v4.GetTagRequest
 */
export type GetTagRequest = Message<"legebill.site.tag.v4.GetTagRequest"> & {
  /**
   * @generated from field: string tag_id = 1;
   */
  tagId: string;
};

/**
 * Describes the message legebill.site.tag.v4.GetTagRequest.
 * Use `create(GetTagRequestSchema)` to create a new message.
 */
export const GetTagRequestSchema: GenMessage<GetTagRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 0);

/**
 * @generated from message legebill.site.tag.v4.UpdateTagRequest
 */
export type UpdateTagRequest = Message<"legebill.site.tag.v4.UpdateTagRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: legebill.site.tag.v4.TagUpdate tag = 2;
   */
  tag?: TagUpdate;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 3;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message legebill.site.tag.v4.UpdateTagRequest.
 * Use `create(UpdateTagRequestSchema)` to create a new message.
 */
export const UpdateTagRequestSchema: GenMessage<UpdateTagRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 1);

/**
 * TagUpdate fields must be a subset of Tag fields.
 *
 * @generated from message legebill.site.tag.v4.TagUpdate
 */
export type TagUpdate = Message<"legebill.site.tag.v4.TagUpdate"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: legebill.type.Tag.SuggestionConfig suggestion_config = 3;
   */
  suggestionConfig: Tag_SuggestionConfig;

  /**
   * full list should be send to update the field (not diff), empty list to clear all
   *
   * @generated from field: repeated legebill.type.DefaultTimesheetFieldValue default_timesheet_field_values = 5;
   */
  defaultTimesheetFieldValues: DefaultTimesheetFieldValue[];
};

/**
 * Describes the message legebill.site.tag.v4.TagUpdate.
 * Use `create(TagUpdateSchema)` to create a new message.
 */
export const TagUpdateSchema: GenMessage<TagUpdate> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 2);

/**
 * @generated from message legebill.site.tag.v4.ListTagsByCategoryRequest
 */
export type ListTagsByCategoryRequest = Message<"legebill.site.tag.v4.ListTagsByCategoryRequest"> & {
  /**
   * @generated from field: string tag_category_id = 1;
   */
  tagCategoryId: string;
};

/**
 * Describes the message legebill.site.tag.v4.ListTagsByCategoryRequest.
 * Use `create(ListTagsByCategoryRequestSchema)` to create a new message.
 */
export const ListTagsByCategoryRequestSchema: GenMessage<ListTagsByCategoryRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 3);

/**
 * @generated from message legebill.site.tag.v4.ListTagsByCategoryResponse
 */
export type ListTagsByCategoryResponse = Message<"legebill.site.tag.v4.ListTagsByCategoryResponse"> & {
  /**
   * @generated from field: repeated legebill.type.Tag tags = 1;
   */
  tags: Tag[];
};

/**
 * Describes the message legebill.site.tag.v4.ListTagsByCategoryResponse.
 * Use `create(ListTagsByCategoryResponseSchema)` to create a new message.
 */
export const ListTagsByCategoryResponseSchema: GenMessage<ListTagsByCategoryResponse> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 4);

/**
 * @generated from message legebill.site.tag.v4.BatchListTagsByCategoriesRequest
 */
export type BatchListTagsByCategoriesRequest = Message<"legebill.site.tag.v4.BatchListTagsByCategoriesRequest"> & {
  /**
   * @generated from field: repeated string tag_category_ids = 1;
   */
  tagCategoryIds: string[];
};

/**
 * Describes the message legebill.site.tag.v4.BatchListTagsByCategoriesRequest.
 * Use `create(BatchListTagsByCategoriesRequestSchema)` to create a new message.
 */
export const BatchListTagsByCategoriesRequestSchema: GenMessage<BatchListTagsByCategoriesRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 5);

/**
 * @generated from message legebill.site.tag.v4.BatchListTagsByCategoriesResponse
 */
export type BatchListTagsByCategoriesResponse = Message<"legebill.site.tag.v4.BatchListTagsByCategoriesResponse"> & {
  /**
   * @generated from field: repeated legebill.site.tag.v4.TagCategoryMembership tags_by_categories = 1;
   */
  tagsByCategories: TagCategoryMembership[];
};

/**
 * Describes the message legebill.site.tag.v4.BatchListTagsByCategoriesResponse.
 * Use `create(BatchListTagsByCategoriesResponseSchema)` to create a new message.
 */
export const BatchListTagsByCategoriesResponseSchema: GenMessage<BatchListTagsByCategoriesResponse> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 6);

/**
 * @generated from message legebill.site.tag.v4.TagCategoryMembership
 */
export type TagCategoryMembership = Message<"legebill.site.tag.v4.TagCategoryMembership"> & {
  /**
   * @generated from field: string tag_category_id = 1;
   */
  tagCategoryId: string;

  /**
   * @generated from field: repeated legebill.type.Tag tags = 2;
   */
  tags: Tag[];
};

/**
 * Describes the message legebill.site.tag.v4.TagCategoryMembership.
 * Use `create(TagCategoryMembershipSchema)` to create a new message.
 */
export const TagCategoryMembershipSchema: GenMessage<TagCategoryMembership> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 7);

/**
 * @generated from message legebill.site.tag.v4.ListTagsRequest
 */
export type ListTagsRequest = Message<"legebill.site.tag.v4.ListTagsRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: uint32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: uint32 results_offset = 3;
   */
  resultsOffset: number;
};

/**
 * Describes the message legebill.site.tag.v4.ListTagsRequest.
 * Use `create(ListTagsRequestSchema)` to create a new message.
 */
export const ListTagsRequestSchema: GenMessage<ListTagsRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 8);

/**
 * @generated from message legebill.site.tag.v4.ListTagsResponse
 */
export type ListTagsResponse = Message<"legebill.site.tag.v4.ListTagsResponse"> & {
  /**
   * @generated from field: repeated legebill.type.Tag tags = 1;
   */
  tags: Tag[];

  /**
   * The total number of matches found for the given listing request.
   * If 'results_count' is greater than the number of tags return in
   * this response, it indicates that there are multiple pages available.
   *
   * @generated from field: uint64 results_count = 2;
   */
  resultsCount: bigint;
};

/**
 * Describes the message legebill.site.tag.v4.ListTagsResponse.
 * Use `create(ListTagsResponseSchema)` to create a new message.
 */
export const ListTagsResponseSchema: GenMessage<ListTagsResponse> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 9);

/**
 * @generated from message legebill.site.tag.v4.DeleteAllConnectorTagsRequest
 */
export type DeleteAllConnectorTagsRequest = Message<"legebill.site.tag.v4.DeleteAllConnectorTagsRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;
};

/**
 * Describes the message legebill.site.tag.v4.DeleteAllConnectorTagsRequest.
 * Use `create(DeleteAllConnectorTagsRequestSchema)` to create a new message.
 */
export const DeleteAllConnectorTagsRequestSchema: GenMessage<DeleteAllConnectorTagsRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 10);

/**
 * @generated from message legebill.site.tag.v4.SearchTagsRequest
 */
export type SearchTagsRequest = Message<"legebill.site.tag.v4.SearchTagsRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * If search_text is blank, this RPC lists tags without filtering by text.
   *
   * @generated from field: string search_text = 2;
   */
  searchText: string;

  /**
   * @generated from field: uint32 page_size = 3;
   */
  pageSize: number;

  /**
   * Used for pagination
   *
   * @generated from field: string page_token = 5;
   */
  pageToken: string;

  /**
   * @generated from field: legebill.site.tag.v4.SearchTagsRequest.OrderBy order_by = 4;
   */
  orderBy: SearchTagsRequest_OrderBy;

  /**
   * @generated from field: legebill.type.Tag.Source source = 6;
   */
  source: Tag_Source;
};

/**
 * Describes the message legebill.site.tag.v4.SearchTagsRequest.
 * Use `create(SearchTagsRequestSchema)` to create a new message.
 */
export const SearchTagsRequestSchema: GenMessage<SearchTagsRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 11);

/**
 * @generated from enum legebill.site.tag.v4.SearchTagsRequest.OrderBy
 */
export enum SearchTagsRequest_OrderBy {
  /**
   * @generated from enum value: ORDER_BY_UNSPECIFIED = 0;
   */
  ORDER_BY_UNSPECIFIED = 0,

  /**
   * @generated from enum value: RELEVANCE = 1;
   */
  RELEVANCE = 1,

  /**
   * @generated from enum value: NAME = 2;
   */
  NAME = 2,
}

/**
 * Describes the enum legebill.site.tag.v4.SearchTagsRequest.OrderBy.
 */
export const SearchTagsRequest_OrderBySchema: GenEnum<SearchTagsRequest_OrderBy> = /*@__PURE__*/
  enumDesc(file_legebill_site_tag_v4_tag, 11, 0);

/**
 * @generated from message legebill.site.tag.v4.SearchTagsResponse
 */
export type SearchTagsResponse = Message<"legebill.site.tag.v4.SearchTagsResponse"> & {
  /**
   * @generated from field: repeated legebill.type.Tag tags = 1;
   */
  tags: Tag[];

  /**
   * The total number of matches found for the given search request. If 'results_count' is
   * greater than the number of tags return in this response, it indicates
   * that there are multiple pages available.
   *
   * @generated from field: uint64 results_count = 2;
   */
  resultsCount: bigint;

  /**
   * If there is next page available, this token will be not empty. empty token means no more pages available.
   *
   * @generated from field: string next_page_token = 3;
   */
  nextPageToken: string;
};

/**
 * Describes the message legebill.site.tag.v4.SearchTagsResponse.
 * Use `create(SearchTagsResponseSchema)` to create a new message.
 */
export const SearchTagsResponseSchema: GenMessage<SearchTagsResponse> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 12);

/**
 * @generated from message legebill.site.tag.v4.SearchTagsResponseShallow
 */
export type SearchTagsResponseShallow = Message<"legebill.site.tag.v4.SearchTagsResponseShallow"> & {
  /**
   * @generated from field: repeated legebill.type.TagShallow tags_shallow = 1;
   */
  tagsShallow: TagShallow[];
};

/**
 * Describes the message legebill.site.tag.v4.SearchTagsResponseShallow.
 * Use `create(SearchTagsResponseShallowSchema)` to create a new message.
 */
export const SearchTagsResponseShallowSchema: GenMessage<SearchTagsResponseShallow> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 13);

/**
 * @generated from message legebill.site.tag.v4.BatchGetTagsRequest
 */
export type BatchGetTagsRequest = Message<"legebill.site.tag.v4.BatchGetTagsRequest"> & {
  /**
   * @generated from field: repeated string tag_ids = 1;
   */
  tagIds: string[];
};

/**
 * Describes the message legebill.site.tag.v4.BatchGetTagsRequest.
 * Use `create(BatchGetTagsRequestSchema)` to create a new message.
 */
export const BatchGetTagsRequestSchema: GenMessage<BatchGetTagsRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 14);

/**
 * @generated from message legebill.site.tag.v4.BatchGetTagsResponse
 */
export type BatchGetTagsResponse = Message<"legebill.site.tag.v4.BatchGetTagsResponse"> & {
  /**
   * List of tags that could be looked up by ID.
   *
   * @generated from field: repeated legebill.type.Tag tags = 1;
   */
  tags: Tag[];
};

/**
 * Describes the message legebill.site.tag.v4.BatchGetTagsResponse.
 * Use `create(BatchGetTagsResponseSchema)` to create a new message.
 */
export const BatchGetTagsResponseSchema: GenMessage<BatchGetTagsResponse> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 15);

/**
 * @generated from message legebill.site.tag.v4.CreateTagRequest
 */
export type CreateTagRequest = Message<"legebill.site.tag.v4.CreateTagRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: repeated string keywords = 4;
   */
  keywords: string[];

  /**
   * @generated from field: legebill.type.Tag.SuggestionConfig suggestion_config = 6;
   */
  suggestionConfig: Tag_SuggestionConfig;

  /**
   * @generated from field: repeated legebill.type.DefaultTimesheetFieldValue default_timesheet_field_values = 7;
   */
  defaultTimesheetFieldValues: DefaultTimesheetFieldValue[];
};

/**
 * Describes the message legebill.site.tag.v4.CreateTagRequest.
 * Use `create(CreateTagRequestSchema)` to create a new message.
 */
export const CreateTagRequestSchema: GenMessage<CreateTagRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 16);

/**
 * @generated from message legebill.site.tag.v4.CreateTagKeywordRequest
 */
export type CreateTagKeywordRequest = Message<"legebill.site.tag.v4.CreateTagKeywordRequest"> & {
  /**
   * @generated from field: legebill.type.TagKeyword keyword = 1;
   */
  keyword?: TagKeyword;
};

/**
 * Describes the message legebill.site.tag.v4.CreateTagKeywordRequest.
 * Use `create(CreateTagKeywordRequestSchema)` to create a new message.
 */
export const CreateTagKeywordRequestSchema: GenMessage<CreateTagKeywordRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 17);

/**
 * @generated from message legebill.site.tag.v4.DeleteTagKeywordRequest
 */
export type DeleteTagKeywordRequest = Message<"legebill.site.tag.v4.DeleteTagKeywordRequest"> & {
  /**
   * @generated from field: legebill.type.TagKeyword keyword = 1;
   */
  keyword?: TagKeyword;
};

/**
 * Describes the message legebill.site.tag.v4.DeleteTagKeywordRequest.
 * Use `create(DeleteTagKeywordRequestSchema)` to create a new message.
 */
export const DeleteTagKeywordRequestSchema: GenMessage<DeleteTagKeywordRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 18);

/**
 * @generated from message legebill.site.tag.v4.ListFavouriteTagsRequest
 */
export type ListFavouriteTagsRequest = Message<"legebill.site.tag.v4.ListFavouriteTagsRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;
};

/**
 * Describes the message legebill.site.tag.v4.ListFavouriteTagsRequest.
 * Use `create(ListFavouriteTagsRequestSchema)` to create a new message.
 */
export const ListFavouriteTagsRequestSchema: GenMessage<ListFavouriteTagsRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 19);

/**
 * @generated from message legebill.site.tag.v4.ListFavouriteTagsResponse
 */
export type ListFavouriteTagsResponse = Message<"legebill.site.tag.v4.ListFavouriteTagsResponse"> & {
  /**
   * @generated from field: repeated legebill.site.tag.v4.FavouriteTag favourite_tags = 1;
   */
  favouriteTags: FavouriteTag[];
};

/**
 * Describes the message legebill.site.tag.v4.ListFavouriteTagsResponse.
 * Use `create(ListFavouriteTagsResponseSchema)` to create a new message.
 */
export const ListFavouriteTagsResponseSchema: GenMessage<ListFavouriteTagsResponse> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 20);

/**
 * @generated from message legebill.site.tag.v4.FavouriteTag
 */
export type FavouriteTag = Message<"legebill.site.tag.v4.FavouriteTag"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: legebill.type.Tag tag = 2;
   */
  tag?: Tag;

  /**
   * @generated from field: uint32 site_list_index = 3;
   */
  siteListIndex: number;

  /**
   * @generated from field: google.protobuf.Timestamp create_time = 4;
   */
  createTime?: Timestamp;
};

/**
 * Describes the message legebill.site.tag.v4.FavouriteTag.
 * Use `create(FavouriteTagSchema)` to create a new message.
 */
export const FavouriteTagSchema: GenMessage<FavouriteTag> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 21);

/**
 * @generated from message legebill.site.tag.v4.CreateFavouriteTagRequest
 */
export type CreateFavouriteTagRequest = Message<"legebill.site.tag.v4.CreateFavouriteTagRequest"> & {
  /**
   * @generated from field: string tag_id = 1;
   */
  tagId: string;
};

/**
 * Describes the message legebill.site.tag.v4.CreateFavouriteTagRequest.
 * Use `create(CreateFavouriteTagRequestSchema)` to create a new message.
 */
export const CreateFavouriteTagRequestSchema: GenMessage<CreateFavouriteTagRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 22);

/**
 * @generated from message legebill.site.tag.v4.ReorderFavouriteTagRequest
 */
export type ReorderFavouriteTagRequest = Message<"legebill.site.tag.v4.ReorderFavouriteTagRequest"> & {
  /**
   * @generated from field: string favourite_tag_id = 1;
   */
  favouriteTagId: string;

  /**
   * Each site has an independent list index that starts from 0.
   *
   * @generated from field: uint32 site_list_index = 2;
   */
  siteListIndex: number;
};

/**
 * Describes the message legebill.site.tag.v4.ReorderFavouriteTagRequest.
 * Use `create(ReorderFavouriteTagRequestSchema)` to create a new message.
 */
export const ReorderFavouriteTagRequestSchema: GenMessage<ReorderFavouriteTagRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 23);

/**
 * @generated from message legebill.site.tag.v4.ReorderFavouriteTagResponse
 */
export type ReorderFavouriteTagResponse = Message<"legebill.site.tag.v4.ReorderFavouriteTagResponse"> & {
};

/**
 * Describes the message legebill.site.tag.v4.ReorderFavouriteTagResponse.
 * Use `create(ReorderFavouriteTagResponseSchema)` to create a new message.
 */
export const ReorderFavouriteTagResponseSchema: GenMessage<ReorderFavouriteTagResponse> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 24);

/**
 * @generated from message legebill.site.tag.v4.DeleteFavouriteTagRequest
 */
export type DeleteFavouriteTagRequest = Message<"legebill.site.tag.v4.DeleteFavouriteTagRequest"> & {
  /**
   * @generated from field: string favourite_tag_id = 1;
   */
  favouriteTagId: string;
};

/**
 * Describes the message legebill.site.tag.v4.DeleteFavouriteTagRequest.
 * Use `create(DeleteFavouriteTagRequestSchema)` to create a new message.
 */
export const DeleteFavouriteTagRequestSchema: GenMessage<DeleteFavouriteTagRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 25);

/**
 * @generated from message legebill.site.tag.v4.ListRecentTagsRequest
 */
export type ListRecentTagsRequest = Message<"legebill.site.tag.v4.ListRecentTagsRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: uint32 page_size = 2;
   */
  pageSize: number;

  /**
   * yyyyMMdd
   *
   * @generated from field: uint32 activity_date = 3;
   */
  activityDate: number;
};

/**
 * Describes the message legebill.site.tag.v4.ListRecentTagsRequest.
 * Use `create(ListRecentTagsRequestSchema)` to create a new message.
 */
export const ListRecentTagsRequestSchema: GenMessage<ListRecentTagsRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 26);

/**
 * @generated from message legebill.site.tag.v4.ListRecentTagsResponse
 */
export type ListRecentTagsResponse = Message<"legebill.site.tag.v4.ListRecentTagsResponse"> & {
  /**
   * Ordered with most relevant first.
   *
   * @generated from field: repeated legebill.type.Tag recent_tags = 1;
   */
  recentTags: Tag[];
};

/**
 * Describes the message legebill.site.tag.v4.ListRecentTagsResponse.
 * Use `create(ListRecentTagsResponseSchema)` to create a new message.
 */
export const ListRecentTagsResponseSchema: GenMessage<ListRecentTagsResponse> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 27);

/**
 * @generated from message legebill.site.tag.v4.DeleteTagRequest
 */
export type DeleteTagRequest = Message<"legebill.site.tag.v4.DeleteTagRequest"> & {
  /**
   * @generated from field: string tag_id = 1;
   */
  tagId: string;
};

/**
 * Describes the message legebill.site.tag.v4.DeleteTagRequest.
 * Use `create(DeleteTagRequestSchema)` to create a new message.
 */
export const DeleteTagRequestSchema: GenMessage<DeleteTagRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 28);

/**
 * @generated from message legebill.site.tag.v4.GetTagCategoryRequest
 */
export type GetTagCategoryRequest = Message<"legebill.site.tag.v4.GetTagCategoryRequest"> & {
  /**
   * @generated from field: string tag_category_id = 1;
   */
  tagCategoryId: string;
};

/**
 * Describes the message legebill.site.tag.v4.GetTagCategoryRequest.
 * Use `create(GetTagCategoryRequestSchema)` to create a new message.
 */
export const GetTagCategoryRequestSchema: GenMessage<GetTagCategoryRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 29);

/**
 * @generated from message legebill.site.tag.v4.BatchGetTagCategoriesRequest
 */
export type BatchGetTagCategoriesRequest = Message<"legebill.site.tag.v4.BatchGetTagCategoriesRequest"> & {
  /**
   * @generated from field: repeated string tag_category_ids = 1;
   */
  tagCategoryIds: string[];
};

/**
 * Describes the message legebill.site.tag.v4.BatchGetTagCategoriesRequest.
 * Use `create(BatchGetTagCategoriesRequestSchema)` to create a new message.
 */
export const BatchGetTagCategoriesRequestSchema: GenMessage<BatchGetTagCategoriesRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 30);

/**
 * @generated from message legebill.site.tag.v4.BatchGetTagCategoriesResponse
 */
export type BatchGetTagCategoriesResponse = Message<"legebill.site.tag.v4.BatchGetTagCategoriesResponse"> & {
  /**
   * List of tag categories that could be looked up by ID.
   *
   * @generated from field: repeated legebill.type.TagCategory tag_categories = 1;
   */
  tagCategories: TagCategory[];
};

/**
 * Describes the message legebill.site.tag.v4.BatchGetTagCategoriesResponse.
 * Use `create(BatchGetTagCategoriesResponseSchema)` to create a new message.
 */
export const BatchGetTagCategoriesResponseSchema: GenMessage<BatchGetTagCategoriesResponse> = /*@__PURE__*/
  messageDesc(file_legebill_site_tag_v4_tag, 31);

/**
 * Resources of the Tag service API include:
 *
 * - sites/*\/tags/*
 * - sites/*\/tags/*\/tag-keywords/*
 * - sites/*\/favourite-tags/*
 *
 *
 * @generated from service legebill.site.tag.v4.TagService
 */
export const TagService: GenService<{
  /**
   * Tag fields in use:
   *
   * - id
   * - name
   * - description
   * - keywords
   * - suggestion_config
   * - site_id
   *
   * Possible failures:
   *
   * - INVALID_ARGUMENT:  Request is invalid (one or more required fields are missing or in an invalid format)
   * - NOT_FOUND:         Tag does not exist
   * - PERMISSION_DENIED: User is not a member of the site that owns the tag
   *
   * @generated from rpc legebill.site.tag.v4.TagService.GetTag
   */
  getTag: {
    methodKind: "unary";
    input: typeof GetTagRequestSchema;
    output: typeof TagSchema;
  },
  /**
   * Batch get tags by their IDs.
   * Note that response may contain less than the number of requested tags if some of them are not found
   * or if the user doesn't have access to them.
   *
   * Tag fields in use:
   *
   * - id
   * - name
   * - description
   * - external_url
   * - site_id
   *
   * Possible failures:
   *
   * - INVALID_ARGUMENT:  Request is invalid: At least one tag ID is required
   *
   * @generated from rpc legebill.site.tag.v4.TagService.BatchGetTags
   */
  batchGetTags: {
    methodKind: "unary";
    input: typeof BatchGetTagsRequestSchema;
    output: typeof BatchGetTagsResponseSchema;
  },
  /**
   * Create a new tag.
   *
   * Possible failures:
   *
   * - INVALID_ARGUMENT:    Request is invalid: tag name is required, tag name and keyword should be max 500 characters
   * - ALREADY_EXISTS:      The tag name already exists
   * - FAILED_PRECONDITION: Team already has too many tags (e.g. Starter can have Up to 40 team tags)
   *
   * @generated from rpc legebill.site.tag.v4.TagService.CreateTag
   */
  createTag: {
    methodKind: "unary";
    input: typeof CreateTagRequestSchema;
    output: typeof TagSchema;
  },
  /**
   * Tag fields in use:
   *
   * - id
   * - name
   * - description
   * - site_id
   *
   * Possible failures:
   *
   * - INVALID_ARGUMENT:  Request is invalid (one or more required fields are missing or in an invalid format)
   * - NOT_FOUND:         Tag does not exist
   * - ALREADY_EXISTS:    Tag with same name already exists
   * - PERMISSION_DENIED: User doesn't have permission edit tags
   *
   * @generated from rpc legebill.site.tag.v4.TagService.UpdateTag
   */
  updateTag: {
    methodKind: "unary";
    input: typeof UpdateTagRequestSchema;
    output: typeof TagSchema;
  },
  /**
   * List tags belonging to a category.
   *
   * Possible failures:
   *
   * - INVALID_ARGUMENT:  Request is invalid: tag_category_id is required.
   * - NOT_FOUND:         Tag category with this ID does not exist.
   * - PERMISSION_DENIED: User doesn't have permission to view this tag category.
   *
   * @generated from rpc legebill.site.tag.v4.TagService.ListTagsByCategory
   */
  listTagsByCategory: {
    methodKind: "unary";
    input: typeof ListTagsByCategoryRequestSchema;
    output: typeof ListTagsByCategoryResponseSchema;
  },
  /**
   * Batch list tags belonging to categories.
   * Note that response may contain less than number of requested tag categories if some of them are not found
   * or if the user doesn't have access to them.
   *
   * Possible failures:
   *
   * - INVALID_ARGUMENT:  Request is invalid: at least one tag category ID is required.
   *
   * @generated from rpc legebill.site.tag.v4.TagService.BatchListTagsByCategories
   */
  batchListTagsByCategories: {
    methodKind: "unary";
    input: typeof BatchListTagsByCategoriesRequestSchema;
    output: typeof BatchListTagsByCategoriesResponseSchema;
  },
  /**
   * Tag fields in use:
   *
   * - id
   * - name
   * - description
   * - site_id
   *
   * Possible error statuses:
   *
   * - INVALID_ARGUMENT:  Request is invalid (one or more required fields are missing or in an invalid format)
   * - PERMISSION_DENIED: User is not a member of the site that owns the tag
   *
   * @generated from rpc legebill.site.tag.v4.TagService.ListTags
   */
  listTags: {
    methodKind: "unary";
    input: typeof ListTagsRequestSchema;
    output: typeof ListTagsResponseSchema;
  },
  /**
   * Delete all connector-created tags
   *
   * Possible failures:
   *
   * - INVALID_ARGUMENT:    Request is invalid (one or more required fields are missing or in an invalid format)
   * - PERMISSION_DENIED:   User should be allowed to delete connector tags
   *
   * @generated from rpc legebill.site.tag.v4.TagService.DeleteAllConnectorTags
   */
  deleteAllConnectorTags: {
    methodKind: "unary";
    input: typeof DeleteAllConnectorTagsRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Tag fields in use:
   *
   * - id
   * - name
   * - description
   * - site_id
   *
   * Possible error statuses:
   *
   * - INVALID_ARGUMENT:  Request is invalid (one or more required fields are missing or in an invalid format)
   * - PERMISSION_DENIED: User is not a member of the site that owns the tag
   *
   * @generated from rpc legebill.site.tag.v4.TagService.SearchTags
   */
  searchTags: {
    methodKind: "unary";
    input: typeof SearchTagsRequestSchema;
    output: typeof SearchTagsResponseSchema;
  },
  /**
   * Returns a shallow copy (minimum required fields) of matched tags.
   *
   * @generated from rpc legebill.site.tag.v4.TagService.SearchTagsShallow
   */
  searchTagsShallow: {
    methodKind: "unary";
    input: typeof SearchTagsRequestSchema;
    output: typeof SearchTagsResponseShallowSchema;
  },
  /**
   * Possible failures:
   *
   * - ALREADY_EXISTS:    Tag already has requested keyword
   * - INVALID_ARGUMENT:  Request is invalid (one or more required fields are missing or in an invalid format)
   * - NOT_FOUND:         Tag does not exist
   * - PERMISSION_DENIED: User doesn't have permission to edit tags
   *
   * @generated from rpc legebill.site.tag.v4.TagService.CreateTagKeyword
   */
  createTagKeyword: {
    methodKind: "unary";
    input: typeof CreateTagKeywordRequestSchema;
    output: typeof TagKeywordSchema;
  },
  /**
   * Possible failures:
   *
   * - NOT_FOUND:         Tag not found or doesn't contains requested keyword
   * - INVALID_ARGUMENT:  Request is invalid (one or more required fields are missing or in an invalid format)
   * - PERMISSION_DENIED: User doesn't have permission to edit tags
   *
   * @generated from rpc legebill.site.tag.v4.TagService.DeleteTagKeyword
   */
  deleteTagKeyword: {
    methodKind: "unary";
    input: typeof DeleteTagKeywordRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Tag fields in use (excluding fields exclusive to favourite tag):
   *
   * - id
   * - name
   * - description
   * - site_id
   *
   * Possible failures:
   *
   * - NOT_FOUND:         Site not found
   * - INVALID_ARGUMENT:  Request is invalid (one or more required fields are missing or in an invalid format)
   * - PERMISSION_DENIED: User is not a member of the site that owns the tag
   *
   * @generated from rpc legebill.site.tag.v4.TagService.ListFavouriteTags
   */
  listFavouriteTags: {
    methodKind: "unary";
    input: typeof ListFavouriteTagsRequestSchema;
    output: typeof ListFavouriteTagsResponseSchema;
  },
  /**
   * Tag fields in use (excluding fields exclusive to favourite tag):
   *
   * - id
   * - name
   * - description
   * - site_id
   *
   * Possible failures:
   *
   * - NOT_FOUND:         Tag not found
   * - INVALID_ARGUMENT:  Request is invalid (one or more required fields are missing or in an invalid format)
   * - PERMISSION_DENIED: User is not a member of the site that owns the tag
   *
   * @generated from rpc legebill.site.tag.v4.TagService.CreateFavouriteTag
   */
  createFavouriteTag: {
    methodKind: "unary";
    input: typeof CreateFavouriteTagRequestSchema;
    output: typeof FavouriteTagSchema;
  },
  /**
   * Possible failures:
   *
   * - INVALID_ARGUMENT:  Request is invalid (one or more required fields are missing or in an invalid format)
   * - PERMISSION_DENIED: User is not a member of the site that owns the tag
   *
   * @generated from rpc legebill.site.tag.v4.TagService.ReorderFavouriteTag
   */
  reorderFavouriteTag: {
    methodKind: "unary";
    input: typeof ReorderFavouriteTagRequestSchema;
    output: typeof ReorderFavouriteTagResponseSchema;
  },
  /**
   * Possible failures:
   *
   * - INVALID_ARGUMENT:  Request is invalid (one or more required fields are missing or in an invalid format)
   * - PERMISSION_DENIED: User is not a member of the site that owns the tag
   *
   * @generated from rpc legebill.site.tag.v4.TagService.DeleteFavouriteTag
   */
  deleteFavouriteTag: {
    methodKind: "unary";
    input: typeof DeleteFavouriteTagRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Tag fields in use:
   *
   * - id
   * - name
   * - description
   * - site_id
   *
   * Possible failures:
   *
   * - NOT_FOUND:         Site not found
   * - INVALID_ARGUMENT:  Request is invalid (one or more required fields are missing or in an invalid format)
   * - PERMISSION_DENIED: User doesn't have permission to edit tags
   *
   * @generated from rpc legebill.site.tag.v4.TagService.ListRecentTags
   */
  listRecentTags: {
    methodKind: "unary";
    input: typeof ListRecentTagsRequestSchema;
    output: typeof ListRecentTagsResponseSchema;
  },
  /**
   * Possible failures:
   *
   * - INVALID_ARGUMENT:    Request is invalid (one or more required fields are missing or in an invalid format)
   * - NOT_FOUND:           Tag does not exist
   * - FAILED_PRECONDITION: Concurrency issue, tag removed during method execution
   * - PERMISSION_DENIED:   User should be allowed to edit tags
   *
   * @generated from rpc legebill.site.tag.v4.TagService.DeleteTag
   */
  deleteTag: {
    methodKind: "unary";
    input: typeof DeleteTagRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Possible failures:
   *
   * - INVALID_ARGUMENT:  Request is invalid (one or more required fields are missing or in an invalid format)
   * - NOT_FOUND:         Tag category does not exist
   * - PERMISSION_DENIED: User is not a member of the site that owns the tag category
   *
   * @generated from rpc legebill.site.tag.v4.TagService.GetTagCategory
   */
  getTagCategory: {
    methodKind: "unary";
    input: typeof GetTagCategoryRequestSchema;
    output: typeof TagCategorySchema;
  },
  /**
   * Batch get tag categories by their IDs.
   * Note that response may contain less than the number of requested tag categories if some of them are not found
   * or if the user doesn't have access to them.
   *
   * Possible failures:
   *
   * - INVALID_ARGUMENT:  Request is invalid: At least one tag category ID is required
   *
   * @generated from rpc legebill.site.tag.v4.TagService.BatchGetTagCategories
   */
  batchGetTagCategories: {
    methodKind: "unary";
    input: typeof BatchGetTagCategoriesRequestSchema;
    output: typeof BatchGetTagCategoriesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_legebill_site_tag_v4_tag, 0);

